import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BaseModal, languageChangeRequest, languageOptions, Button, localStorageKey } from 'yankees-react-utils';
import { Row, Col } from 'react-bootstrap';
import { store } from '../store';

const LanguageModal = ({ showModal, setShowModal, modalContainer }) => {
    const { state: { user: loggedInUser } } = useContext(store);
    const { t: translate, i18n } = useTranslation();
    const isDeveloper = !!loggedInUser.Roles.find((r) => r.RoleName === 'developer');
    const localeCodeLocalStorage = window.localStorage.getItem('localeCode');
    const curLang = i18n.language;
    const isCimode = translate('locale') !== i18n.language;

    const doChangeLanguage = (locale) => {
        i18n.changeLanguage(locale);
        languageChangeRequest(locale);
        setShowModal(false);
    };

    const doResetPreference = () => {
        window.localStorage.removeItem(localStorageKey); // delete the current language pref and re-load (re-detect)
        window.location.reload();
    };

    return (
        <BaseModal
            show={showModal}
            onHide={() => setShowModal(false)}
            container={modalContainer}
        >
            <BaseModal.Header>
                {translate('nav.language-settings')}
            </BaseModal.Header>
            <BaseModal.Body>
                <Row>
                    {Object.keys(languageOptions).map((locale) => (
                        <Col md={3} key={locale}>
                            <Button variant={i18n.resolvedLanguage === locale ? 'success' : 'primary'} type="submit" onClick={() => doChangeLanguage(locale)} style={{ marginBottom: '10px' }}>
                                {languageOptions[locale].title}
                            </Button>
                        </Col>
                    ))}
                    {isDeveloper && (
                        <>
                            <Col md={3} key="dev">
                                <Button variant={isCimode ? 'success' : 'primary'} type="submit" onClick={() => doChangeLanguage('cimode')}>
                                    Dev Keys
                                </Button>
                            </Col>
                        </>
                    )}
                </Row>
                <hr />
                <Row>
                    <Col md={12}>
                        <Button variant="danger" type="submit" onClick={() => doResetPreference()}>
                            {translate('nav.language-reset')}
                        </Button>
                    </Col>
                </Row>
                {isDeveloper && (
                    <>
                        <hr />
                        <a href="/explode" className="btn btn-sm btn-warning">Explode i18n File</a>
                        <hr />
                        Locale Code Local Storage: {localeCodeLocalStorage}<br />
                        i18n Current Language: {curLang}<br />
                        isCimode: {isCimode ? 'Yes' : 'No'}
                        <hr />
                        Site: {translate('site')}<br />
                        Library Version: {translate('translationVersion')}<br />
                        Language Name: {translate('languageNameEnglish')}<br />
                    </>
                )}
            </BaseModal.Body>
            <BaseModal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>{translate('common.close')}</Button>
            </BaseModal.Footer>
        </BaseModal>
    );
};

LanguageModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    modalContainer: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default LanguageModal;
